import type { UserRoleTypeEnum } from 'gql/graphql'

export const userRoles = {
  admin: 'admin',
  adops: 'adops',
  backOffice: 'backOffice',
  customerPerformance: 'customerPerformance',
  customerSuccess: 'customerSuccess',
  publisher: 'publisher',
} as const satisfies Record<string, UserRole>

export type UserRole = UserRoleTypeEnum
